import {Lang} from 'yougile-lang'
import {Util, Time} from 'yougile-util'

import {Backend} from '../../common/backend'
import {DataObjectId} from 'yougile-model'
import {UserAccount, youGileUserId} from 'yougile-model'

export class UserAvatarUtils {
  private static colors: string[] = [
    '#f30868',
    '#e2a42d',
    '#b3282d',
    '#333e48',
    '#48a3d4',
    '#1883ad',
    '#3fae2a',
    '#403853'
  ]

  public static avaColorByName(
    username: string,
    fallback: string,
    opacity?: number
  ): string {
    opacity = opacity ?? 1
    if (!username || username === '_') {
      username = fallback || '_'
    }
    const hash = username
      .split('')
      .map((s: string) => s.charCodeAt(0))
      .reduce((a: number, b: number) => a + b)
    return (
      'rgba(' +
      Util.colorToRGB(
        UserAvatarUtils.colors[hash % UserAvatarUtils.colors.length]
      ).join(',') +
      ', ' +
      opacity +
      ')'
    )
  }

  public static avaShortName(
    username: string,
    user: {id: DataObjectId; email: string}
  ): string {
    if (user.id === youGileUserId) {
      return 'Y.'
    }
    if (!username || username === '_') {
      username = user.email || '_'
    }
    username = username.trim()
    if (username.split(' ').length > 1) {
      const let1 = username.split(' ')[0]
      const let2 = username.split(' ')[1]
      return let1[0].toUpperCase() + (let2[0] || '').toUpperCase()
    } else {
      const twoLetters = (username.replace(/-/g, '') + 'AA').slice(0, 2)
      return twoLetters[0].toUpperCase() + (twoLetters[1] || '').toLowerCase()
    }
  }

  public static preview(avatar: string): string {
    if (avatar.includes('_____previews_')) {
      return Backend.toDataUrl(
        avatar.split('_____previews_')[0] + '-256-preview.png'
      )
    } else if (avatar.includes('previews[]=-256-')) {
      const ava = avatar
      const file = ava.split('?').shift()
      const suffix =
        '-256-' +
        ava.split('previews[]=-256-').pop().split('&').shift() +
        '.png'
      return Backend.toDataUrl(file + suffix)
    } else {
      return avatar && Backend.toDataUrl(avatar)
    }
  }

  public static hintInfo(account: UserAccount, email: string): string {
    let statusHint = Lang.msg.userOnline
    if (account.status === 'offline') {
      statusHint = account.lastActivity
        ? Lang.msg.userOfflineSeenAt + Time.formatDateTime(account.lastActivity)
        : Lang.msg.userOffline
    } else if (UserAccount.isInDnd(account)) {
      statusHint = Lang.msg.userDnd + Time.formatDateTime(account.dndUntil)
    }
    const realName =
      account?.realName && account.realName !== '_' ? account.realName : email

    return Lang.msg.user + ': ' + realName + '. ' + statusHint
  }
}
